import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
   selector: 'app-financiamento-card',
   standalone: true,
   imports: [CommonModule, MatDialogModule, MatIcon, MatButton],
   templateUrl: './financiamento-card.component.html',
   styleUrl: './financiamento-card.component.scss'
})
export class FinanciamentoCardComponent {
   constructor(public router: Router) {}

     acessaContato() {
      this.router.navigate(['/contato']);
   }
}


